/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.sync.getRepo";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"did":/*#__PURE__*/ l.string({"format":"did"}),"since":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"tid"}))});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("application/vnd.ipld.car");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Download a repository export as CAR file. Optionally only a 'diff' since a previous revision. Does not require auth; implemented by PDS. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["RepoNotFound","RepoTakendown","RepoSuspended","RepoDeactivated"]);

export { main };

export const $lxm = $nsid;
